<template lang="pug">
  .private-router-link(@click="handleRedirection()")
    slot
</template>

<script>
import { mapState } from 'vuex'
import PubSub from 'pubsub-js'

export default {
  name: 'PrivateRouterLink',
  props: {
    to: Object,
  },
  computed: mapState(['token']),
  data() {
    return {}
  },
  created() {},
  methods: {
    handleRedirection: function() {
      if (this.token) {
        this.$router.push(this.to)
      } else {
        // Save a temporal value on local storage (redirection) and redirect
        // to login
        let objectToStore = JSON.stringify(this.to)
        localStorage.setItem(window.PREFIX + 'redirectOnLogin', objectToStore)
        // Shows the popup of the login
        PubSub.publish('login.show', null)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/directives/PrivateRouterLink.vue